export enum Routes {
  INFO = 'info',
  STATISTICS = 'statistics',
  COMPLETED_TOURNAMENTS = 'completed_tournaments',
  FEE_STATISTICS = 'fee_statistics',
  ACCOUNT_STATEMENT = 'account_statement',
  GAME_HISTORY = 'game_history'
}
